import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import ReportAssessment from '../report/Assessment/ReportAssessment';
import ReportTemplate from '../report/AssessmentTemplate';
import TaskRealm from '../task/TaskRealm/TaskRealm';
import TaskDetail from '../task/TaskDetail';
import NavBar from './NavBar';
import Home from './Home';
import Changelog from './Changelog';
import { PerformEditionPage, PerformLibraryPage, PerformTasksPage, PerformReportsPage, PerformCoursesPage, PerformCourseEditionsPage } from './Content';

export default withRouter((props) => {
  return (
    <>
      <NavBar hide={props.hide} changeRealm={props.changeRealm} realm={props.realm} pageTitle={props.title} pageValue={props.match.params.base || false} />
      <Switch>
        <Route exact path="/home" render={(match) => <Home realm={props.realm} changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/library" render={(match) => <PerformEditionPage realm={props.realm} changeTitle={props.changeTitle} requiredNav={'library'} {...match} />} />
        <Route path="/library/:library" render={(match) => <PerformLibraryPage realm={props.realm} requiredNav={'library'} changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/courses" render={(match) => <PerformCoursesPage realm={props.realm} changeTitle={props.changeTitle} requiredNav={'library'} {...match} />} />
        <Route path="/courses/:id" render={(match) => <PerformCourseEditionsPage realm={props.realm} requiredNav={'library'} changeTitle={props.changeTitle} {...match} />} />
        <Route path="/tasks/list/:id" render={(match) => <TaskRealm realm={props.realm} requiredNav={'tasks'} onRealmChange={() => props.history.push('/tasks/list')} {...match} />} />
        <Route path="/tasks/detail/:id" render={(match) => <TaskDetail {...match} requiredNav={'tasks'} />} />
        <Route exact path="/tasks" render={(match) => <PerformTasksPage realm={props.realm} requiredNav={'tasks'} changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/tasks/:display" render={(match) => <PerformTasksPage realm={props.realm} requiredNav={'tasks'} changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/tasks/:display/:realmid" render={(match) => <PerformTasksPage realm={props.realm} requiredNav={'tasks'} changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/reports" render={(match) => <PerformReportsPage realm={props.realm} requiredNav={'assessments'} changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/reports/:display" render={(match) => <PerformReportsPage realm={props.realm} requiredNav={'assessments'} changeTitle={props.changeTitle} {...match} />} />
        <Route
          path="/reports/assessment/:id"
          render={(match) => <ReportAssessment realm={props.realm} requiredNav={'assessments'} onRealmChange={() => props.history.push('/reports/list')} {...match} />}
        />
        <Route
          path="/reports/assessment-template/:id"
          render={(match) => <ReportTemplate realm={props.realm} requiredNav={'assessments'} onRealmChange={() => props.history.push('/reports/list')} {...match} />}
        />
        <Route path="/changelog" render={() => <Changelog />} />
      </Switch>
    </>
  );
});
